import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { isMobileContainer } from '../../utils/device';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line,
} from 'recharts';

export default function CrmCharts({ charts = {} }) {
  const weekly = charts.weekly_inquiries || [];
  const monthly = charts.monthly_inquiries || [];
  const joins = charts.school_joins || [];
  const targets = charts.target_achievement || [];
  const chartHeight = isMobileContainer() ? 'h-48' : 'h-64';

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <Card className="border-border">
        <CardHeader><CardTitle className="text-base">Weekly Inquiries</CardTitle></CardHeader>
        <CardContent className={chartHeight}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={weekly}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 10 }} />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Line type="monotone" dataKey="count" stroke="#3b82f6" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card className="border-border">
        <CardHeader><CardTitle className="text-base">Monthly Inquiries (30 days)</CardTitle></CardHeader>
        <CardContent className={chartHeight}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={monthly}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 9 }} />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="count" fill="#8b5cf6" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card className="border-border">
        <CardHeader><CardTitle className="text-base">School Joins (6 months)</CardTitle></CardHeader>
        <CardContent className={chartHeight}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={joins}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" tick={{ fontSize: 10 }} />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="count" fill="#10b981" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      {targets.length > 0 && (
        <Card className="border-border">
          <CardHeader><CardTitle className="text-base">Target Achievement</CardTitle></CardHeader>
          <CardContent className={chartHeight}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={targets}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" tick={{ fontSize: 9 }} />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="achieved" fill="#f59e0b" name="Achieved" />
                <Bar dataKey="target" fill="#e5e7eb" name="Target" />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
